import React from 'react'
import { observer } from 'mobx-react'
import { format } from 'd3-format'
import { ageBuckets, genderLabels } from 'constants.js'
import { translate } from 'utils.js'

const BarHover = ({
  analysis,
  height,
  barX,
  barWidth
}) => (
  analysis.hoveredPyramid
    ? (
      <g
        className='detail' transform={translate(
          barX(analysis.hoveredPyramid) + barWidth / 2,
          height
        )}
      >
        <line y2='38' />
        <text x='-4' y='19' className='heading'>
          <tspan>{genderLabels.get(analysis.hoveredPyramid.gender)} </tspan>
          <tspan>{ageBuckets.get(analysis.hoveredPyramid.age)}</tspan>
        </text>
        <text x='-4' y='35'>{format(',.0f')(analysis.hoveredPyramid.value)} </text>
      </g>
      )
    : null
)

export default observer(BarHover)
